import { render, staticRenderFns } from "./projectView.vue?vue&type=template&id=04c7b29e&scoped=true"
import script from "./projectView.vue?vue&type=script&lang=js"
export * from "./projectView.vue?vue&type=script&lang=js"
import style0 from "./projectView.vue?vue&type=style&index=0&id=04c7b29e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c7b29e",
  null
  
)

export default component.exports